import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import type { CardPaymentDetailsDto } from '@api/models';
import { CopyButtonComponent } from '@/components/copy-button/copy-button.component';
import { formatCardNumber } from '@/helpers/format-card-number.function';
import { LanguageService } from '@/services/language/language.service';

/**
 * The bank details an order is paid to: the amount still due, how long the invoice holds, one block
 * per bank with every line copyable, and who to tell once it is paid. Shown on its own page (the link
 * in the payment-details email and SMS) and on the order-success page.
 */
@Component({
  selector: 'cmt-card-payment-details',
  templateUrl: './card-payment-details.component.html',
  styleUrls: ['./card-payment-details.component.scss'],
  imports: [DatePipe, DecimalPipe, TranslatePipe, CopyButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardPaymentDetailsComponent {
  protected languageService = inject(LanguageService);

  readonly details = input.required<CardPaymentDetailsDto>();

  protected readonly formatCardNumber = formatCardNumber;

  /** What the customer writes in the transfer's purpose, and copies */
  protected paymentReference(details: CardPaymentDetailsDto): string {
    return `${this.languageService.getTranslationInstant('global.order')} №${details.orderId}`;
  }
}
